export default __webpack_public_path__ + "src/docs/packages/villa-54-victoria.pdf";